// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { RouteIDGroup } from "../Groups/GroupsImport.js";
import { Message } from "./Message.ts"
import { PFixMessage } from "./PFixMessage.js"
export let NewsRequestMessage = function ()
{
    this.Code = Message.CODE_NEWS_REQUEST_MESSAGE;
    PFixMessage.call(this);
}
NewsRequestMessage.prototype = Object.create(PFixMessage.prototype);

NewsRequestMessage.prototype.setRouteId = function (routeID)
{
    let group = new RouteIDGroup()
    group.setRouteId(routeID)

    this.addGroup(group)
}

NewsRequestMessage.prototype.setNumber = function (number)
{
    this.setFieldValue(FieldsFactory.FIELD_NUMBER, number);
}

NewsRequestMessage.prototype.setStartTime = function (startTime)
{
    this.setFieldValue(FieldsFactory.FIELD_START_TIME, startTime);
}

NewsRequestMessage.prototype.setEndTime = function (endTime)
{
    this.setFieldValue(FieldsFactory.FIELD_END_DAY_DATE, endTime);
}

NewsRequestMessage.prototype.setSymbol = function (value)
{
    this.setFieldValue(FieldsFactory.FIELD_SYMBOL, value);
}

NewsRequestMessage.prototype.setSource = function (value)
{
    this.setFieldValue(FieldsFactory.FIELD_SOURCE, value);
}

NewsRequestMessage.prototype.setNewsCategory = function (value)
{
    this.setFieldValue(FieldsFactory.FIELD_NEWS_CATEGORY, value);
}

NewsRequestMessage.prototype.setPriority = function (value)
{
    this.setFieldValue(FieldsFactory.FIELD_PRIORITY, value);
}

NewsRequestMessage.prototype.setTheme = function (value)
{
    this.setFieldValue(FieldsFactory.FIELD_THEME, value);
}

NewsRequestMessage.prototype.setIsUpperCaseSearch = function (value)
{
    this.setFieldValue(FieldsFactory.FIELD_IS_UPPRCASE_SEARCH, value);
}

NewsRequestMessage.prototype.setIsContentSearch = function (value)
{
    this.setFieldValue(FieldsFactory.FIELD_IS_CONTENT_SEARCH, value);
}

NewsRequestMessage.prototype.setIsEventSearch = function (value)
{
    this.setFieldValue(FieldsFactory.FIELD_IS_EVENT_SEARCH, value);
}

